import React from 'react';
import { isEmpty } from 'lodash';
import SharedDialog from '../../../global/Modal/Modal';
import { SaveFiltersDialogProps } from '../types';
import { getFilterLabel } from '../../../modules/search/searchGrid/helpers/getFiltersLabels';

const SaveFiltersDialog: React.FC<SaveFiltersDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  tab,
  view,
  source,
  searchItems,
  pendingFiltersToSave,
}) => {
  return (
    <SharedDialog
      isOpen={isOpen}
      onClose={onClose}
      title="Do you want to save this search?"
      confirmText="Yes"
      cancelText="No"
      hasConfirmBtn
      onConfirm={onConfirm}
    >
      <div className="grid">
        <span>
          <strong>Tab: </strong>
          {tab}
        </span>
        <span>
          <strong>View: </strong>
          {view}
        </span>
        <span>
          <strong>Source: </strong>
          {source}
        </span>
        {!isEmpty(searchItems) && (
          <span>
            <strong>Idents: </strong>
            {searchItems.map((item) => item.id).join(', ')}
          </span>
        )}
        <div>
          {pendingFiltersToSave && pendingFiltersToSave.length > 0 && (
            <>
              <strong>Filters: </strong>
              {pendingFiltersToSave.map(filter => getFilterLabel(filter)).join(', ')}
            </>
          )}
        </div>
      </div>
    </SharedDialog>
  );
};

export default SaveFiltersDialog;